import React from "react";
import { Link } from "react-router-dom";
import { EdSupportBg, EventsBg, SponsorshipBg } from "../../assets";

const ProgramSection = () => {
  return (
    <div
      className="flex flex-col lg:flex-row items-center justify-center py-6 md:py-10 lg:py-16 xl:py-20 gap-4 md:gap-6 lg:gap-6 bg-primaryBg px-4 sm:px-6 md:px-8 lg:px-12"
      data-aos="fade-up"
      data-aos-duration="3000">
      
      {/* First Card - Seekh */}
      <div className="relative w-full lg:w-[32%] h-[280px] sm:h-[300px] md:h-[400px] lg:h-[500px] overflow-hidden rounded-lg">
        <Link to="/seekh" className="block w-full h-full">
          <img src={EdSupportBg} alt="Ed Support bg" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/20 hover:bg-black/10 transition-all duration-300"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 md:p-8 lg:p-10 space-y-3 md:space-y-6">
            <div className="space-y-3 md:space-y-4">
              <div className="font-Poppins text-white text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold">
                Seekh
              </div>
              <div className="font-Poppins text-white text-sm sm:text-base md:text-xl lg:text-2xl lg:leading-10 leading-relaxed">
                After-school class support for underprivileged students across all the Bhavishya NGO Centres pan India.
              </div>
            </div>
            <div className="flex justify-end pt-2 md:pt-4">
              <button className="font-Poppins text-white text-xs sm:text-sm md:text-lg lg:text-2xl px-4 md:px-6 py-2 md:py-3 bg-secondaryBg rounded-lg hover:opacity-90 transition duration-300 whitespace-nowrap">
                help us help them
              </button>
            </div>
          </div>
        </Link>
      </div>

      {/* Second Card - Programs */}
      <div className="relative w-full lg:w-[32%] h-[280px] sm:h-[300px] md:h-[400px] lg:h-[500px] overflow-hidden rounded-lg">
        <img
          src={EventsBg}
          alt="Events bg"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/20 hover:bg-black/10 transition-all duration-300"></div>
        <Link to="/programs" className="block w-full h-full">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="font-Poppins lg:-rotate-90 text-white text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-extrabold text-center">
              Programs
            </div>
          </div>
        </Link>
      </div>

      {/* Third Card - Sponsorship */}
      <div className="relative w-full lg:w-[32%] h-[280px] sm:h-[300px] md:h-[400px] lg:h-[500px] overflow-hidden rounded-lg">
        <img
          src={SponsorshipBg}
          alt="Sponsorship bg"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/20 hover:bg-black/10 transition-all duration-300"></div>
        <Link to="/donate" className="block w-full h-full">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="font-Poppins lg:-rotate-90 text-white text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-center">
              Sponsorship
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ProgramSection;